import { Box } from "@mui/material";
import { Check } from "@mui/icons-material";
import { Colors } from "Components/Layout/Themes/Colors";
import type { ReactNode } from "react";

const CIRCLE_SIZE = 32;
const ICON_SIZE = 18;

type Props = {
  icon: ReactNode;
  isCompleted: boolean;
  inactiveColor?: string;
};

export const TimelineIcon = ({ icon, isCompleted, inactiveColor }: Props) => {
  const backgroundColor = isCompleted
    ? Colors.Green
    : inactiveColor || Colors.PrimaryMain;
  const color = Colors.White;

  return (
    <Box
      width={CIRCLE_SIZE}
      height={CIRCLE_SIZE}
      zIndex={2}
      flexShrink={0}
      color={color}
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      borderRadius="50%"
      sx={{ backgroundColor }}
    >
      {isCompleted ? (
        <Check sx={{ fontSize: ICON_SIZE }} />
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ "& svg": { fontSize: ICON_SIZE, color } }}
        >
          {icon}
        </Box>
      )}
    </Box>
  );
};
